import { render, staticRenderFns } from "./AddWmsService.vue?vue&type=template&id=36ad8f42"
import script from "./AddWmsService.vue?vue&type=script&lang=js"
export * from "./AddWmsService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports